import { LinkButton, Icon, Typography } from "@bca/ui-library";
import React from "react";
import { useSelector, useDispatch } from "react-redux";

import analytics from "../common/analytics/analytics";
import { IEventPushable } from "../common/analytics/analytics.types";
import { StoreType } from "../StoreType";
import { Links } from "../vehicle-search-details/vehicleSearch.type";
import { handlePrintExportFile } from "../utils/handlePrintExportFile";
import { GET_STATE } from "../redux/slices/appSlice";
import { useAuth } from "@bca-auth0/bca-auth0-provider";

const pushPrintAllAnalytics = () => {
  analytics.push<IEventPushable>({
    event: {
      name: "click",
      category: "link",
      label: "print",
      action: "print",
      section: "search-ellipsis",
    },
  });
};

const PrintAllButton: React.FunctionComponent<{
  printAllLink: Links;
  pdfEnabled?: boolean;
}> = ({ printAllLink, pdfEnabled }) => {
  const dispatch = useDispatch();
  const store: StoreType = useSelector(GET_STATE);

  const { accessToken } = useAuth(!store.app.isToUseAuthZero);

  const handlePrintFile = () => {
    if (pdfEnabled && Boolean(printAllLink?.href)) {
      handlePrintExportFile(
        dispatch,
        printAllLink.href,
        printAllLink.rel,
        accessToken,
        store.app.isToUseAuthZero
      );
      pushPrintAllAnalytics();
    }
  };

  return (
    <LinkButton
      data-testid="ellipsis-print-all"
      variant="tertiary"
      height="30px"
      px={0}
      target="_blank"
      href={
        !pdfEnabled && Boolean(printAllLink?.href) ? printAllLink.href : null
      }
      onClick={handlePrintFile}
      css={
        (!Boolean(printAllLink?.href) || store.app?.isLoadingFile) &&
        `
        opacity: 0.3;
        cursor: default;
      `
      }
    >
      <Icon
        width="16px"
        name="print"
        weight="regular"
        color="primary-light-blue"
        mb="2px"
        mr={2}
      ></Icon>
      <Typography
        color="primary-light-blue"
        variant="body"
        my="0"
        css={`
          text-decoration: underline;
        `}
      >
        Print all vehicles
      </Typography>
    </LinkButton>
  );
};

export default PrintAllButton;
